define([
	"dojo/_base/declare",
	"./NewSupplierRequest"
], function(declare,NewSupplierRequest) {

	return declare(NewSupplierRequest, {
		fixedType: "DataPackageContainerType:Material",
		productField: "Materials"
	});
});